module.exports = __webpack_public_path__ + "media/images/ohap_quiz_bank_on-457c72d210e9ac3924200e5099bf8602.png";